import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

import authModule from "./auth/moduleAuth";
import usermanagement from "./user-management/moduleUserManagement";
import users from "./users/moduleUsers";
import libraries from "./libraries/moduleLibraries";
import objects from "./objects/moduleObjects";
import moderation from "./moderation/moduleModeration";
import emissions from "./emissions/moduleEmissions";
import minselxoz from "./minselxoz/index";
import goskomgeologiya from "./goskomgeologiya/index";
import uzgidromet from "./uzgidromet/index";
import minvodxoz from "./minvodxoz/index";
import goskomles from "./goskomles/moduleGoskomles";
import help from "./help";
import statistics from "./statistics";
import admin from "./admin";
import moduleReports from "./reports/moduleReports";
import faq from "./faq";
import socket from "./socket/socket";
import additional from "./additional";

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: authModule,
    management: usermanagement,
    users: users,
    libraries: libraries,
    objects: objects,
    moderation: moderation,
    emissions: emissions,
    minselxoz,
    goskomgeologiya,
    uzgidromet,
    minvodxoz,
    goskomles: goskomles,
    reports: moduleReports,
    help,
    statistics,
    admin,
    faq,
    socket,
    additional
  },
  // strict: process.env.NODE_ENV !== 'production'
});
